import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const initialState = {
  country: '',
  countryName: '',
  date_from: '',
  date_to: '',
  searchTxt: '',
};

export const searchDraftSlice = createSlice({
  name: 'searchDraft',
  initialState,
  reducers: {
    searchDraftUpdate: (state, action) => action.payload,
  },
});

export const searchDraftSelect = (state) => state.searchDraft;
export const { searchDraftUpdate } = searchDraftSlice.actions;
export default searchDraftSlice.reducer;
